// Generated by ts-to-zod
import { z } from 'zod';

export const loginPayloadSchema = z.object({
  username: z.string(),
  password: z.string(),
  scope: z.string().optional(),
  origin: z.string().optional(),
});
